/**
 * UI Store
 * Centralized state management for UI state shared between components
 * (document loading state)
 */

import { createStore } from 'zustand/vanilla';
import { devtools } from 'zustand/middleware';

type DocumentLoadingState = 'none' | 'loading' | 'loaded';

interface UIState {
  // State
  documentLoadingState: DocumentLoadingState;

  // Actions
  setDocumentLoadingState: (state: DocumentLoadingState) => void;
  reset: () => void;
}

const initialState = {
  documentLoadingState: 'none' as DocumentLoadingState,
};

export const useUIStore = createStore<UIState>()(
  devtools(
    (set) => ({
      // Initial state
      ...initialState,

      // Actions
      setDocumentLoadingState: (documentLoadingState) =>
        set({ documentLoadingState }, false, 'setDocumentLoadingState'),

      reset: () => set({ ...initialState }, false, 'reset'),
    }),
    { name: 'UIStore', enabled: !import.meta.env.PROD }
  )
);

// Export type for external use
export type { UIState, DocumentLoadingState };
